export default "__VITE_ASSET__D4cois7___"